export default (state=[], action) =>{
    let query = {};
    switch(action.type){
        case 'SET_STATUS_CHECK_RADIO':
            query = {
                code: action.payload.code,
                selection: {
                    filter: 'item',
                    values: action.payload.values
                }
            }
            return state.map(q => (q.code === action.payload.code ? query : q));
    }
}
